/**
 * Icônes SVG inline style Lucide (MIT).
 * Chaque fonction retourne un élément SVG DOM.
 */

/**
 * @param {string} paths - Contenu SVG interne (path, circle, line, rect…)
 * @param {number} [size=24]
 * @returns {SVGSVGElement}
 */
function createIcon(paths, size = 24) {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('width', String(size));
  svg.setAttribute('height', String(size));
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('fill', 'none');
  svg.setAttribute('stroke', 'currentColor');
  svg.setAttribute('stroke-width', '2');
  svg.setAttribute('stroke-linecap', 'round');
  svg.setAttribute('stroke-linejoin', 'round');
  svg.setAttribute('aria-hidden', 'true');
  svg.classList.add('icon');
  svg.innerHTML = paths;
  return svg;
}

export function iconStore(size) {
  return createIcon(
    '<path d="m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7"/><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/><path d="M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4"/><path d="M2 7h20"/><path d="M22 7v3a2 2 0 0 1-2 2a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12a2 2 0 0 1-2-2V7"/>',
    size,
  );
}

export function iconCart(size) {
  return createIcon(
    '<circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/>',
    size,
  );
}

export function iconMapPin(size) {
  return createIcon(
    '<path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"/><circle cx="12" cy="10" r="3"/>',
    size,
  );
}

export function iconPackage(size) {
  return createIcon(
    '<path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z"/><path d="M12 22V12"/><path d="m3.3 7 7.703 4.734a2 2 0 0 0 1.994 0L20.7 7"/><path d="m7.5 4.27 9 5.15"/>',
    size,
  );
}

export function iconPlus(size) {
  return createIcon(
    '<path d="M5 12h14"/><path d="M12 5v14"/>',
    size,
  );
}

export function iconCheck(size) {
  return createIcon(
    '<path d="M20 6 9 17l-5-5"/>',
    size,
  );
}

export function iconSettings(size) {
  return createIcon(
    '<path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/><circle cx="12" cy="12" r="3"/>',
    size,
  );
}

export function iconTrash(size) {
  return createIcon(
    '<path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/><line x1="10" x2="10" y1="11" y2="17"/><line x1="14" x2="14" y1="11" y2="17"/>',
    size,
  );
}

export function iconArrowLeft(size) {
  return createIcon(
    '<path d="m12 19-7-7 7-7"/><path d="M19 12H5"/>',
    size,
  );
}

export function iconChevronRight(size) {
  return createIcon(
    '<path d="m9 18 6-6-6-6"/>',
    size,
  );
}

export function iconClipboardList(size) {
  return createIcon(
    '<rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><path d="M12 11h4"/><path d="M12 16h4"/><path d="M8 11h.01"/><path d="M8 16h.01"/>',
    size,
  );
}

export function iconGripVertical(size) {
  return createIcon(
    '<circle cx="9" cy="12" r="1"/><circle cx="9" cy="5" r="1"/><circle cx="9" cy="19" r="1"/><circle cx="15" cy="12" r="1"/><circle cx="15" cy="5" r="1"/><circle cx="15" cy="19" r="1"/>',
    size,
  );
}

export function iconX(size) {
  return createIcon(
    '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>',
    size,
  );
}

export function iconSearch(size) {
  return createIcon(
    '<circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/>',
    size,
  );
}

export function iconAlertTriangle(size) {
  return createIcon(
    '<path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"/><path d="M12 9v4"/><path d="M12 17h.01"/>',
    size,
  );
}

export function iconSmile(size) {
  return createIcon(
    '<circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><line x1="9" x2="9.01" y1="9" y2="9"/><line x1="15" x2="15.01" y1="9" y2="9"/>',
    size,
  );
}

export function iconSun(size) {
  return createIcon(
    '<circle cx="12" cy="12" r="4"/><path d="M12 2v2"/><path d="M12 20v2"/><path d="m4.93 4.93 1.41 1.41"/><path d="m17.66 17.66 1.41 1.41"/><path d="M2 12h2"/><path d="M20 12h2"/><path d="m6.34 17.66-1.41 1.41"/><path d="m19.07 4.93-1.41 1.41"/>',
    size,
  );
}

export function iconMoon(size) {
  return createIcon(
    '<path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"/>',
    size,
  );
}

export function iconMessageSquare(size) {
  return createIcon(
    '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>',
    size,
  );
}

export function iconStar(size) {
  return createIcon(
    '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>',
    size,
  );
}

export function iconPencil(size) {
  return createIcon(
    '<path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"/><path d="m15 5 4 4"/>',
    size,
  );
}

export function iconShare(size) {
  return createIcon(
    '<path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" x2="12" y1="2" y2="15"/>',
    size,
  );
}

export function iconMic(size) {
  return createIcon(
    '<path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" x2="12" y1="19" y2="22"/>',
    size,
  );
}

export function iconMicOff(size) {
  return createIcon(
    '<line x1="2" x2="22" y1="2" y2="22"/><path d="M18.89 13.23A7.12 7.12 0 0 0 19 12v-2"/><path d="M5 10v2a7 7 0 0 0 12 5"/><path d="M15 9.34V5a3 3 0 0 0-5.68-1.33"/><path d="M9 9v3a3 3 0 0 0 5.12 2.12"/><line x1="12" x2="12" y1="19" y2="22"/>',
    size,
  );
}

export function iconCheckCircle(size) {
  return createIcon(
    '<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><path d="m9 11 3 3L22 4"/>',
    size,
  );
}

export function iconShoppingBag(size) {
  return createIcon(
    '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/>',
    size,
  );
}

export function iconGlobe(size) {
  return createIcon(
    '<circle cx="12" cy="12" r="10"/><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"/><path d="M2 12h20"/>',
    size,
  );
}

export function iconThumbsUp(size) {
  return createIcon(
    '<path d="M7 10v12"/><path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z"/>',
    size,
  );
}

export function iconUpload(size) {
  return createIcon(
    '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" x2="12" y1="3" y2="15"/>',
    size,
  );
}

export function iconDownload(size) {
  return createIcon(
    '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" x2="12" y1="15" y2="3"/>',
    size,
  );
}

export function iconNavigation(size) {
  return createIcon(
    '<polygon points="3 11 22 2 13 21 11 13 3 11"/>',
    size,
  );
}

export function iconUser(size) {
  return createIcon(
    '<path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>',
    size,
  );
}

export function iconLogOut(size) {
  return createIcon(
    '<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" x2="9" y1="12" y2="12"/>',
    size,
  );
}

export function iconLogIn(size) {
  return createIcon(
    '<path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><polyline points="10 17 15 12 10 7"/><line x1="15" x2="3" y1="12" y2="12"/>',
    size,
  );
}

export function iconMail(size) {
  return createIcon(
    '<rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>',
    size,
  );
}

export function iconLock(size) {
  return createIcon(
    '<rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>',
    size,
  );
}

export function iconRefreshCw(size) {
  return createIcon(
    '<path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/><path d="M3 21v-5h5"/>',
    size,
  );
}

/**
 * Logo GroceWise — checklist + bouton + (style claymorphism du brand).
 * Rempli, pas stroke Lucide.
 */
export function iconLeafLogo(size = 28) {
  const uid = `gw${Math.random().toString(36).slice(2, 7)}`;
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('width', String(size));
  svg.setAttribute('height', String(size));
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('fill', 'none');
  svg.setAttribute('aria-hidden', 'true');
  svg.classList.add('icon', 'icon-leaf-logo');
  svg.innerHTML = `
    <defs>
      <linearGradient id="${uid}-bg" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stop-color="#E8F5EC"/>
        <stop offset="100%" stop-color="#D4EDDA"/>
      </linearGradient>
      <linearGradient id="${uid}-btn" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stop-color="#5CBF88"/>
        <stop offset="100%" stop-color="#3D9465"/>
      </linearGradient>
    </defs>
    <rect width="24" height="24" fill="url(#${uid}-bg)"/>
    <g transform="translate(12,11.5) rotate(-12)">
      <rect x="-6.2" y="-7.2" width="12.4" height="14.4" rx="2" fill="#fff"/>
      <circle cx="-3.4" cy="-3.2" r="1.15" fill="#4CAF78"/>
      <path d="M-3.9 -3.2 L-3.5 -2.8 L-2.9 -3.6" stroke="#fff" stroke-width="0.35" stroke-linecap="round" fill="none"/>
      <rect x="-1.6" y="-3.55" width="5.2" height="0.7" rx="0.35" fill="#A7D780"/>
      <circle cx="-3.4" cy="0.2" r="1.15" fill="#4CAF78"/>
      <path d="M-3.9 0.2 L-3.5 0.6 L-2.9 -0.2" stroke="#fff" stroke-width="0.35" stroke-linecap="round" fill="none"/>
      <rect x="-1.6" y="-0.15" width="4.6" height="0.7" rx="0.35" fill="#A7D780"/>
      <circle cx="-3.4" cy="3.6" r="1.15" fill="#4CAF78"/>
      <path d="M-3.9 3.6 L-3.5 4 L-2.9 3.2" stroke="#fff" stroke-width="0.35" stroke-linecap="round" fill="none"/>
      <rect x="-1.6" y="3.25" width="4" height="0.7" rx="0.35" fill="#A7D780"/>
    </g>
    <line x1="16.5" y1="4.2" x2="18" y2="2.8" stroke="#3D9465" stroke-width="0.7" stroke-linecap="round"/>
    <line x1="18" y1="5.2" x2="19.8" y2="4.4" stroke="#3D9465" stroke-width="0.7" stroke-linecap="round"/>
    <circle cx="16.2" cy="17.2" r="3.2" fill="url(#${uid}-btn)"/>
    <path d="M14.8 17.2 H17.6 M16.2 15.8 V18.6" stroke="#fff" stroke-width="0.9" stroke-linecap="round"/>
  `;
  return svg;
}

export function iconHome(size) {
  return createIcon(
    '<path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"/><path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>',
    size,
  );
}

export function iconList(size) {
  return createIcon(
    '<line x1="8" x2="21" y1="6" y2="6"/><line x1="8" x2="21" y1="12" y2="12"/><line x1="8" x2="21" y1="18" y2="18"/><line x1="3" x2="3.01" y1="6" y2="6"/><line x1="3" x2="3.01" y1="12" y2="12"/><line x1="3" x2="3.01" y1="18" y2="18"/>',
    size,
  );
}
